
// import './managmentpushnotification.scss'
// import React, { useState, useEffect } from "react";
// import { Link, NavLink, useHistory } from "react-router-dom";
// import Button from "react-bootstrap/Button";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import Dropdown from "react-bootstrap/Dropdown";

// import Environment from "utils/environment";
// import axios from "axios";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { isIfStatement } from "typescript";

// const Apppushnotification = () => {
//   const [show, setShow] = useState(false);


//    const resetForm = () => {
//     setTitle("");
//     setDescription("");
//     setImage(null);
//     setBaseImage("");
//   };
// const API_URL = "https://prod-api.quick.shop";
//     // const val = localStorage.getItem("accessToken");



//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const [title, setTitle] = useState("");
//     const [discription, setDiscription] = useState("");
//       const [image, setImage] = useState("");
//         const [baseImage, setBaseImage] = useState("");
      
    

//   const uploadImages = async (e) => {
//     const file = e.target.files[0];
//     const base64 = await convertBase645(file);
//     setBaseImage(base64);
//     setImage(file);
//   };
//   const convertBase645 = (file) => {
//     return new Promise((resolve, reject) => {
//       const fileReader = new FileReader();
//       fileReader.readAsDataURL(file);
//       fileReader.onload = () => {
//         resolve(fileReader.result);
//       };
//       fileReader.onerror = (error) => {
//         reject(error);
//       };
//     });
//   };

//   // ad api for posting notification

 

//     https://prod-api.quick.shop/notifications/push-notification

//   const sendPushNotification = async () => {
//     const token = localStorage.getItem("accessToken");
//     if (!token) {
//       toast.error("Authentication token not found. Please log in.");
//       return;
//     }

//     if (!title.trim() || !discription.trim()) {
//         toast.error("Title and Description are required.");
//         return;
//     }

//     const formData = new FormData();
//     formData.append('title', title);
//     formData.append('description', discription);
//     if (image) {
//       formData.append('notificationImage', image);
//     }
    
//     try {
//       const response = await axios.post(
//         `${API_URL}/notifications/push-notification`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       console.log('Push notification sent:', response.data);
//       toast.success('Notification sent successfully!');
      
//       resetForm();        // Clear the form
//       handleClose();      // Close the sidebar
//       fetchNotifications(); // Refresh the list of notifications
//     } catch (error) {
//       console.error('Push notification failed:', error.response?.data || error.message);
//       toast.error('Failed to send notification.');
//     }
//   };


import './managmentpushnotification.scss';
import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Environment from 'utils/environment';

const API_URL = Environment.base_url4

const Apppushnotification = () => {
  // State for the Offcanvas (sidebar)
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // State for the new notification form fields
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState(""); // Using corrected spelling
  const [image, setImage] = useState(null);
  const [baseImage, setBaseImage] = useState("");

  // --- Image Handling Functions ---
  const uploadImages = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const base64 = await convertBase64(file);
      setBaseImage(base64);
      setImage(file);
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.onerror = (error) => reject(error);
    });
  };
  
  // --- Utility function to clear the form ---
  const resetForm = () => {
    setTitle("");
    setDescription("");
    setImage(null);
    setBaseImage("");
  };

  // --- API Function to send a new notification ---
  const sendPushNotification = async () => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.error("Authentication token not found. Please log in.");
      return;
    }

    if (!title.trim() || !description.trim()) {
        toast.error("Title and Description are required.");
        return;
    }

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    if (image) {
      formData.append('notificationImage', image);
    }
    
    try {
      await axios.post(
        `${API_URL}/notifications/push-notification`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success('Notification sent successfully!');
      
      resetForm();
      handleClose();
    } catch (error) {
      console.error('Push notification failed:', error.response?.data || error.message);
      toast.error('Failed to send notification.');
    }
  };


  return (
    <>
      <div className="headerapppush">
        <h1>Push Notification</h1>
        <button onClick={() => {
          setShow(true);

        }} className='buttonheaderpush'>Create New</button>
      </div>
      <div className="tablepushnotification">

        <div className="table-customer">
          <div className="table-customer">
            <table class="table-custum">
              <thead>
                <tr>
                  <th scope="col">Image</th>
                  <th scope="col"> Title</th>
                  <th scope="col">Date/Time</th>
                  <th scope="col">status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>


                <>
                  <tr className='tablerowss'>
                    <td>
                      <img src="\mystrygiftbox\mystrygitbox.svg" alt="" />
                    </td>
                    <td>
                      This is Title
                    </td>
                    <td>

                      Nov 25, 2021 | 00:00
                    </td>

                    <td>
                      <div className="detailbutton">

                        <span className="blue-span">
                          Scheduled
                        </span>

                        {/* <span className="red-span">
                                          Fired
                                        </span> */}

                      </div>
                    </td>
                    <td>
                      <div className="images">
                        <img
                          src="\assestsss\edit-2.png"
                          className="img-fluid"
                          alt=""

                        />
                        <img
                          src="\assestsss\trash.svg"
                          className="img-fluid"
                          alt=""

                        />
                      </div>
                    </td>
                  </tr >
                  <tr className='tablerowss bottomradioustable'>
                    <td>
                      <img src="\mystrygiftbox\mystrygitbox.svg" alt="" />
                    </td>
                    <td>
                      This is Title
                    </td>
                    <td>

                      Nov 25, 2021 | 00:00
                    </td>

                    <td>
                      <div className="detailbutton">



                        <span className="green-span">
                          Fired
                        </span>

                      </div>
                    </td>
                    <td>
                      <div className="images">
                        <img
                          src="\assestsss\edit-2.png"
                          className="img-fluid"
                          alt=""

                        />
                        <img
                          src="\assestsss\trash.svg"
                          className="img-fluid"
                          alt=""

                        />
                      </div>
                    </td>
                  </tr>
                </>






              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Offcanvas */}



      
        <Offcanvas
          show={show}
          onHide={handleClose}
          className="sidebar-apppushnotification"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Create Notification</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="bannerss">
              <h4>Banner Image</h4>
              {/* <div className="item-upload">
                <ul className="list-inline ">
                  <li className="list-inline-item">
                    <input
                      id="upload"
                      type="file"
                      className="d-none"
                                              onChange={uploadImages}


                    />
                    <label for="upload" className="">
                       {baseImage ? (
                      <img
                            src={baseImage}
                            alt="img"
                            className="img-fluid upload-img"
                          />
  ) : (


                      <>
                        <div className='uploadimgprnt'>
                          <img
                            src="\assestsss\gallery-add.svg"
                            className="img-fluid"
                          />
                          <h4 className="">Drag your image here</h4>
                          <p>
                            (Size 16:9)

                          </p>
                        </div>

                       </>
)}
                     </label>
                  </li>
                </ul>
              </div> */}
                <div className="item-upload">
              <input
                id="upload"
                type="file"
                className="d-none"
                accept="image/*"
                onChange={uploadImages}
              />
              <label htmlFor="upload">
                {baseImage ? (
                  <img src={baseImage} alt="Preview" className="img-fluid upload-img" />
                ) : (
                  <div className='uploadimgprnt'>
                    <img src="/assestsss/gallery-add.svg" className="img-fluid" alt="Upload Icon" />
                    <h4>Drag your image here</h4>
                    <p>(Recommended Size 16:9)</p>
                  </div>
                )}
              </label>
            </div>

              
              <div className="filedinput">


                <input
                  type="text"
                  placeholder="Title"
                   value={title}
                    onChange={(e) => setTitle(e.target.value)}


                />
                <p>Discription</p>
                <textarea
                  className="productarea"
                  placeholder="Product Detail"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}

                />

                <p className="schedulecheackbox">
                  <input className='inputschedule' type="checkbox" />Schedule
                  

                </p>
                <div className="dateandtimecanvas">
                  <p>Date/Time</p>
                  <div className="inputssss">
                    <input className='inputinnercanvasss' type="text" placeholder='DD/MM/YY' />
                    <input className='inputinnercanvasss' type="text" placeholder='Time' />
                  </div>
                </div>







              </div>
              <div className="buttonss">
                <button className="" nClick={() => {
                resetForm();
                handleClose();
              }}>
                  Cancel
                </button>
                <button className="ml-2"
                  onClick={sendPushNotification}
                 >

                  Schedule
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
     




    </>
  )
}

export default Apppushnotification